import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../provider/AppContextProvider';
import { CmpIdentifier, ContentType } from '../helper/enums';
import { TrackingInformationInterface } from '../helper/PageInformationInterface';
import { newTracker, trackPageView, enableActivityTracking, setUserId, addGlobalContexts, clearGlobalContexts } from '@snowplow/browser-tracker';
import { markSnowplowTrackerReady } from '../helper/snowplow';
import { useUser } from '../lib/useUser';
import { ConsentContext } from '../provider/ConsentContextProvider';

declare global {
  interface Window {
    drive: any;
  }
}

interface Data {
  articleId?: string
  paid: boolean
  trackingInformation: TrackingInformationInterface
  contentType: ContentType
}

export function trackConversionWithSnowPlow(productName, price, payment_method) {
  if(!productName || !window || !window.drive) {
		return; // dismiss
	};
	window.drive('trackSelfDescribingEvent', {
		event: {
			schema: 'iglu:de.drive/subscription_context/jsonschema/1-0-0',
			data: {
				action : 'conversion',
				label: 'thankyou-page',
				product: productName,
				price: price,
				payment_method: payment_method
			}
		}
	});
}

export function trackFunnelConversionWithSnowPlow(displayMode, productName, price) {
  if(!productName || !window || !window.drive) {
		return; // dismiss
	};
	window.drive('trackSelfDescribingEvent', {
		event: {
			schema: 'iglu:de.drive/subscription_context/jsonschema/1-0-0',
			data: {
				action : 'funnel-entry',
				label: displayMode,
				product: productName,
				price: price,
				payment_method: null
			}
		}
    });
}
export { trackSubscriptionWithSnowPlow } from '../helper/snowplow';

function getContentType(contentType: ContentType) {
  switch(contentType) {
    case ContentType.Ressort:
      return 'overview';
    case ContentType.Article:
      return 'article';
    case ContentType.Gallery:
      return 'media';
    default:
      return 'article';
  }
}

export default function TrackingSnowPlow(props: Data) {
  const { isAllowedByCmp, subscription } = React.useContext(AppContext);
  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.AtInternet);
  const isTrackingAllowed = cmpVendorId && isAllowedByCmp(cmpVendorId)
  const [tracker, setTracker] = useState(false)

  const [user] = useUser()
  const userId = user ? user.userId : '';
  const userType = (subscription && (subscription.nnPlusApp || subscription.nnPlusWeb)) ? 'premium' : (userId != '' ? 'registered' : 'anonym')
  const trackingInformation = props.trackingInformation;

  useEffect(() => {
    if(!tracker && isTrackingAllowed) {
      newTracker('DriveTracker', `drive-v2.${process.env.NEXT_PUBLIC_DRIVE_URL}`, {
        appId: process.env.NEXT_PUBLIC_DRIVE_APP_ID,
        platform: 'mob',
        contexts : {
            webPage: true
        },
        plugins: [ ],
      })
      enableActivityTracking({
        minimumVisitLength: 5,
        heartbeatDelay: 5
      });
      markSnowplowTrackerReady();
      setTracker(true);
    }
  },[tracker, isTrackingAllowed])

  useEffect(() => {
    if(tracker) {
      const articleId = props.articleId ?? '';
      const articleType = props.articleId ? (props.paid ?  'paid': 'free') : '';
      const contentType = getContentType(props.contentType);
      const contentIsPaywall = false && userType !== 'premium';
      const globalContexts = [{
          schema : 'iglu:de.drive/user_context/jsonschema/1-0-0',
          data   : { userType : userType}
      },
      {
          schema : 'iglu:de.drive/article_context/jsonschema/1-0-0',
          data : {
              articleId : articleId,
              articleType: articleType,
              contentType: contentType,
              contentIsPaywall: contentIsPaywall
          }
      }];

      clearGlobalContexts();
      addGlobalContexts(globalContexts);
      setUserId(userId)
      trackPageView()
      //   {
      // context: [{
      //   schema: 'iglu:de.drive/http_request_context/jsonschema/1-0-0',
      //   data: {
      //     correlation_id : correlationId
      //   }
      // }],
      // contextCallback: function() {
      //   return [{
      //     schema: 'iglu:de.drive/http_request_context/jsonschema/1-0-0',
      //     data: {
      //       correlation_id : correlationId
      //     }
      //   }];
      // }}
    }
  },[tracker, trackingInformation])

  return (<></>
  )
}